module.exports = __webpack_public_path__ + "static/img/role@2x.6691153e.png";